var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBigPurplePhoneLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 248.076,
    height: 28,
    viewBox: "0 0 248.076 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10598",
    "data-name": "Rectangle 10598",
    width: 35.677,
    height: 26.794,
    transform: "translate(0 0)",
    fill: "#bd8ef2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bigPurplePhoneLogo",
    transform: "translate(-157.693 -363.562)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "BigPurplePhone",
    transform: "translate(197.769 386.562)",
    fill: "#bd8ef2",
    fontSize: 23,
    fontFamily: "Raleway-Regular, Raleway"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Big"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fontFamily: "Raleway-Bold, Raleway",
    fontWeight: 700
  }, "Purple"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "Phone")), /*#__PURE__*/React.createElement("g", {
    id: "Group_14568",
    "data-name": "Group 14568",
    transform: "translate(157.693 364.192)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14562",
    "data-name": "Group 14562",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2550",
    "data-name": "Path 2550",
    d: "M60.679,8.759,52.117.556a2.059,2.059,0,0,0-2.814,0L43.645,5.977l6.029,5.78a2.225,2.225,0,0,1,0,3.227,2.409,2.409,0,0,1-1.583.664l.043.041a2.209,2.209,0,0,1,0,3.23,2.416,2.416,0,0,1-1.679.668,2.441,2.441,0,0,1-1.473-.486,2.212,2.212,0,0,1-.694,1.539,2.454,2.454,0,0,1-3.369,0l-.558-.534a2.229,2.229,0,0,1-.693,1.52,2.376,2.376,0,0,1-1.374.649l4.141,3.968a2.064,2.064,0,0,0,2.818,0L60.679,11.458a1.855,1.855,0,0,0,0-2.7m-3.949.2-.017.019a.622.622,0,0,1-.843,0L51.888,5.163a.552.552,0,0,1,0-.8L51.9,4.34a.616.616,0,0,1,.843,0L56.73,8.155a.556.556,0,0,1,0,.808",
    transform: "translate(-25.585 0)",
    fill: "#bd8ef2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2551",
    "data-name": "Path 2551",
    d: "M13.425,19.042,9.058,14.864l.773-.741,6.159,5.9a1.5,1.5,0,0,0,2.054,0,1.356,1.356,0,0,0,0-1.968l-6.162-5.9.77-.741,7.188,6.89a1.5,1.5,0,0,0,2.054,0,1.349,1.349,0,0,0,0-1.971L14.706,9.453l.77-.741,5.907,5.659a1.493,1.493,0,0,0,2.051,0,1.351,1.351,0,0,0,.007-1.962l-.007-.006L17.4,6.623,13.68,3.059,12.615,2.042a7.449,7.449,0,0,0-10.128-.06l-.03.029-.329.312a6.748,6.748,0,0,0,0,9.837l9.239,8.855a.165.165,0,0,0,.027.022.226.226,0,0,0,.043.035,1.5,1.5,0,0,0,1.988-.057,1.359,1.359,0,0,0,0-1.971",
    transform: "translate(0 -0.017)",
    fill: "#bd8ef2"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "\\xAE",
    transform: "translate(379.769 363.562)",
    fill: "#bd8ef2",
    fontSize: 14,
    fontFamily: "Raleway-Regular, Raleway"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 13
  }, "\xAE")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigPurplePhoneLogo);
export default __webpack_public_path__ + "static/media/bigPurplePhoneLogo.19f185ad15b7c38ebaa6dc5fd5686920.svg";
export { ForwardRef as ReactComponent };